// Temporary pilot-phase toggles — one place to find and reverse these
// specific decisions later, not a general feature-flag system.

// Google sign-in/sign-up UI hidden during the pilot (Login.js/Signup.js).
// Flip to true to bring the button back — the OAuth call itself is untouched.
export const GOOGLE_AUTH_ENABLED = false;

// Pricing section hidden on the Landing page during the pilot (Landing.js).
// Flip to true to restore the pricing cards and the nav link to them.
export const PRICING_VISIBLE = false;

// Hardcoded "Ethiopian mini-mart catalog" bulk-import path hidden in
// BulkImport.js — it assumes every store is a mini-mart, which breaks down
// for non-mini-mart pilot stores. Custom file upload is the only path while
// this is false. Flip to true to bring the catalog tab back — the catalog
// data and its import logic are untouched.
export const DEFAULT_CATALOG_IMPORT_ENABLED = false;
